<ul class="social-links__list">
    <li *ngFor="let item of items" class="social-links__item">
        <a
            class="social-links__link social-links__link--type--{{ item.type }}"
            target="_blank"
            [href]="item.url"
        >
        <svg width="1em" height="1em" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <path fill="white" [attr.d]="item.icon"/>
          </svg>
        </a>
    </li>
</ul>
